import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { FaFilePdf } from "react-icons/fa";
import { Checkbox, Table } from "rsuite";
const { Column, HeaderCell, Cell, ColumnGroup } = Table;

function LiquidTable({ data }) {
  const [liquidData, setLiquidData] = useState([]);

  useEffect(() => {
    let runningBalance = data?.lp_id?.amount || 0;
    const commissionAmount = data?.invoice_tomador_comision?.amount || 0;
    const commissionRow = data?.invoice_tomador_comision?._id
      ? {
          date: data?.invoice_tomador_comision?.date,
          number: data?.invoice_tomador_comision?.number || "Pendiente",
          amount: commissionAmount,
          saldo: runningBalance - commissionAmount,
          pdf_url: data?.invoice_tomador_comision?.pdf_url,
          comprobante: "Factura comisión",
        }
      : null;

    if (commissionRow) {
      runningBalance -= commissionAmount;
    }

    const formattedliquidData = [
      {
        date: data?.lp_id?.date,
        lp_date: data?.lp_id?.date,
        lp_number: data?.lp_id?.number,
        lp_amount: data?.lp_id?.amount,
        saldo: data?.lp_id?.amount,
        pdf_url: data?.lp_id?.pdf_url,
        comprobante: "LP",
      },
      ...(commissionRow ? [commissionRow] : []),
      ...(data?.lp_id.paymentOrder_id || [])?.map((order) => {
        runningBalance -= order.amount;
        return {
          ...order,
          saldo: runningBalance,
        };
      }),
    ];

    setLiquidData(formattedliquidData);
  }, [data]);

  return (
    <Row className="mt-4">
      <Col md="12">
        <Table
          height={550}
          bordered
          cellBordered
          wordWrap={true}
          data={liquidData}
        >
          <Column flexGrow={1} align="center">
            <HeaderCell>Fecha</HeaderCell>
            <Cell dataKey="fecha">
              {(rowData) => (
                <p>
                  {moment
                    .utc(rowData.date || rowData.receipt_date)
                    .format("DD/MM/YYYY")}
                </p>
              )}
            </Cell>
          </Column>
          <Column flexGrow={1} align="center">
            <HeaderCell>Comprobante</HeaderCell>
            <Cell dataKey="comprobante">
              {(rowData) => <p>{rowData.comprobante || "Orden pago"}</p>}
            </Cell>
          </Column>
          <Column flexGrow={1} align="right">
            <HeaderCell>Nro de Comprobante</HeaderCell>
            <Cell dataKey="nroComprobante">
              {(rowData) => (
                <p>
                  {rowData.pdf_url && (
                    <a
                      href={rowData.pdf_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Ver PDF"
                    >
                      <FaFilePdf
                        className="mb-2 mr-2"
                        color="primary"
                        size={18}
                      />
                    </a>
                  )}
                  {rowData.lp_number || rowData.number}
                </p>
              )}
            </Cell>
          </Column>
          <Column flexGrow={1} align="right">
            <HeaderCell>Importe</HeaderCell>
            <Cell dataKey="importe">
              {(rowData) => (
                <p>
                  {" "}
                  <CurrencyFormat
                    value={
                      typeof rowData.lp_amount === "number"
                        ? rowData.lp_amount
                        : -rowData.amount
                    }
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                  />
                </p>
              )}
            </Cell>
          </Column>
          <Column flexGrow={1} align="right">
            <HeaderCell align="middle">Saldo</HeaderCell>
            <Cell dataKey="saldo">
              {(rowData) => (
                <p>
                  {" "}
                  <CurrencyFormat
                    value={rowData.saldo}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                  />
                </p>
              )}
            </Cell>
          </Column>
        </Table>
      </Col>
    </Row>
  );
}

export default LiquidTable;
